export default __webpack_public_path__ + "static/media/lock.ba4b15a2.png";